module.exports = __webpack_public_path__ + "img/modulosCom.54455cbc.png";